
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/society/signin",
      function () {
        return require("private-next-pages/society/signin/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/society/signin"])
      });
    }
  